import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LangText } from '@/components';
import { preFixImgUrl } from '@/utils';

export function Footer() {
  const year = new Date().getFullYear();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'phone' | 'email'>('phone');
  const [inputValue, setInputValue] = useState('');

  const goSignup = () => {
    const value = inputValue.trim();
    if (value) {
      navigate('/signup', { state: { account: value, type: activeTab } });
    } else {
      navigate('/signup');
    }
  };

  return (
    <footer className="w-full">
      {/* 上块：背景图 + 手机图 + 文案与注册 + 二维码图 */}
      <div
        className="relative w-full aspect-[1920/767] bg-cover bg-center bg-no-repeat flex items-center overflow-hidden"
        style={{ backgroundImage: `url(${preFixImgUrl('599f8ee455a2cf793506ed074a645e47.png')})` }}
      >
        <div
          className="flex relative z-10 items-center py-16 w-full h-full pr-25"
          style={{
            paddingLeft: 'calc(6.25rem + min(360px, max(180px, 18.75vw)) + 8rem)',
          }}
        >
          <img
            src={preFixImgUrl('2dc698498c7feaecda2f738317f10a6b.png')}
            alt=""
            className="absolute left-40 bottom-[-60px] w-[min(360px,max(180px,18.75vw))] h-auto object-contain object-left-bottom pointer-events-none"
          />
          <div className="flex flex-col w-full text-left mb-25">
            <h2 className="text-white text-[42px] font-bold leading-tight">
              <LangText lngKey="69589067" />
            </h2>
            <p className="text-white/90 text-[20px] mt-6 mb-12">
              <LangText lngKey="5ee19df6" />
            </p>
            <div className="flex gap-8 items-center">
              <div className="flex flex-col">
                <div className="flex gap-2 mb-4">
                  <button
                    type="button"
                    onClick={() => setActiveTab('phone')}
                    className={`px-4 py-2 rounded-lg text-[18px] font-medium transition-colors ${
                      activeTab === 'phone'
                        ? 'bg-[#A6A5A6] text-white opacity-90'
                        : 'bg-transparent text-white'
                    }`}
                  >
                    <LangText lngKey="d009c3b3" />
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('email')}
                    className={`px-4 py-2 rounded-lg text-[18px] font-medium transition-colors ${
                      activeTab === 'email'
                        ? 'bg-[#A6A5A6] text-white opacity-90'
                        : 'bg-transparent text-white'
                    }`}
                  >
                    <LangText lngKey="9b1c6681" />
                  </button>
                </div>
                <div className="rounded-2xl bg-[#A6A5A6]/90 p-2 w-full max-w-[420px]">
                  <div className="flex overflow-hidden items-center">
                    <input
                      type={activeTab === 'phone' ? 'tel' : 'email'}
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      placeholder={activeTab === 'email' ? t('dddc316d') : t('c92b76cd')}
                      className="flex-1 min-w-0 px-4 py-3 bg-transparent text-white text-[16px] placeholder:text-white/90"
                      aria-label="input"
                    />
                    <button
                      type="button"
                      onClick={goSignup}
                      className="flex-shrink-0 px-12 py-3 rounded-[100px] text-[20px] font-bold bg-white hover:opacity-90 transition-opacity ml-4"
                    >
                      <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#A75AFF] to-[#4B51FF]">
                        <LangText lngKey="7a19c71b" />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <img
                src={preFixImgUrl('01dc5f014cfe313db77d863d13d09c0d.png')}
                alt="QR Code"
                className="flex-shrink-0 w-[min(180px,max(90px,9.4vw))] h-[min(180px,max(90px,9.4vw))] object-contain ml-8"
              />
            </div>
          </div>
        </div>
      </div>

      {/* 下块：从上往下渐变，分上下两行 */}
      <div
        className="w-full text-white"
        style={{ background: 'linear-gradient(180deg, #A75AFF, #4B51FF)' }}
      >
        {/* 上部分：品牌 + 三列链接，横向分布 */}
        <div className="flex gap-12 justify-between items-start pt-8 pb-10 mx-auto max-w-12xl px-25">
          <div>
            <span className="text-[36px] font-bold tracking-wider uppercase block">BILION PASS</span>
            <span className="text-[16px] text-white my-3 block"><LangText lngKey="f665074c" /></span>
          </div>
          <div className="flex flex-col gap-4 mt-1 text-left">
            <span className="text-[16px] mb-1"><LangText lngKey="fd6d9e22" /></span>
            <a href="/#travel" className="text-[14px] text-[#ccc] hover:text-white"><LangText lngKey="1127da52" /></a>
            <a href="/#shopping" className="text-[14px] text-[#ccc] hover:text-white"><LangText lngKey="c3d4e5f6" /></a>
            <a href="/#logistics" className="text-[14px] text-[#ccc] hover:text-white"><LangText lngKey="2b2b28ad" /></a>
          </div>
          <div className="flex flex-col gap-4 mt-1 text-left">
            <span className="text-[16px] mb-1"><LangText lngKey="f6db7790" /></span>
            <a href="/about" className="text-[14px] text-[#ccc] hover:text-white"><LangText lngKey="66972f94" /></a>
            <a href="/contact" className="text-[14px] text-[#ccc] hover:text-white"><LangText lngKey="2c7782ea" /></a>
            <a href="/blog" className="text-[14px] text-[#ccc] hover:text-white"><LangText lngKey="2aefb7c1" /></a>
          </div>
          <div className="flex flex-col gap-4 mt-1 text-left">
            <span className="text-[16px] mb-1"><LangText lngKey="d01d50dd" /></span>
            <span className="text-[14px] text-[#ccc] cursor-pointer hover:text-white" onClick={() => window.open('/protocol?id=2', '_blank')}><LangText lngKey="5a8543c4" /></span>
            <span className="text-[14px] text-[#ccc] cursor-pointer hover:text-white" onClick={() => window.open('/protocol?id=3', '_blank')}><LangText lngKey="39d02547" /></span>
          </div>
        </div>
        {/* 下部分：版权左 + 社交图标右，窄条 */}
        <div className="flex justify-between items-center py-4 mx-auto max-w-12xl px-25">
          <span className="text-[14px] text-[#CBCBCB]">© {year} <LangText lngKey="a7ec1656" /></span>
          <div className="flex gap-3 items-center">
            <a href="#" className="block overflow-hidden w-10 h-10 rounded-lg hover:opacity-90"><img src={preFixImgUrl('0bc8aab54660db4b92b9bc29ff2bee1c.png')} alt="小红书" className="object-cover w-full h-full" /></a>
            <a href="#" className="block overflow-hidden w-10 h-10 rounded-lg hover:opacity-90"><img src={preFixImgUrl('b352773c9217c8f910294d3093128796.png')} alt="WeChat" className="object-cover w-full h-full" /></a>
            <a href="#" className="block overflow-hidden w-10 h-10 rounded-lg hover:opacity-90"><img src={preFixImgUrl('83226f5726ad0bfbab1df543b4d09b9a.png')} alt="Instagram" className="object-cover w-full h-full" /></a>
            <a href="#" className="block overflow-hidden w-10 h-10 rounded-lg hover:opacity-90"><img src={preFixImgUrl('93e227bb84e4eb20245b85dc6e6eebff.png')} alt="Twitter" className="object-cover w-full h-full" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
